// @ts-check
import { useState } from 'react'
import { HOSTNAME } from '../../mdc_modules/mdcApiFetch'
import EmailPrompt from './EmailPrompt'

/** @typedef {{ onSuccess: (message: string) => void }} Props */
/** @param {Props} props */
export default function ForgotPassword({ onSuccess }) {
  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState(
    /** @type {Record<string, string | null | undefined>} */ ({})
  )
  const [loading, setLoading] = useState(false)

  /**
   * @param {string | undefined} value
   */
  const handleSubmit = async (value) => {
    const nextEmail = typeof value === 'string' ? value : email
    setLoading(true)
    try {
      const response = await fetch(`${HOSTNAME}/auth/password-recovery`, {
        method: 'POST',
        body: JSON.stringify({
          email: nextEmail,
        }),
      })
      if (response.ok) {
        const { success, message } = await response.json()
        if (success) {
          onSuccess(message)
        } else {
          setErrors({ submissionError: message })
        }
      } else {
        setErrors({
          submissionError: 'Error submitting request. Please try again or contact support.',
        })
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <EmailPrompt
      subtitle="Please enter your email address to receive instructions for resetting your password."
      defaultValue={email}
      primaryLoading={loading}
      error={errors.submissionError}
      onChange={(val) => {
        setEmail(val)
        setErrors((prev) => ({ ...prev, submissionError: null }))
      }}
      onPrimary={handleSubmit}
      primaryLabel="Send Reset Link"
    />
  )
}
